var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Users")]),_c('ResponsiveTable',{attrs:{"headers":['Name', 'Roles', 'Classes', ''],"rows":_vm.users}}),_c('BaseButton',{attrs:{"type":"primary","href":{name: 'AdminUsersCreate'}}},[_vm._v(" Add user ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }